import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../styles/Testimonials.css";
import testimonials from "../data/testimonialsData";

const Testimonials = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [transitionStage, setTransitionStage] = useState("fade-in");

    // Auto change testimonial every 5 seconds with smooth fade + slide
    useEffect(() => {
        const interval = setInterval(() => {
            setTransitionStage("fade-out");
            setTimeout(() => {
                setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
                setTransitionStage("fade-in");
            }, 600); // match CSS transition duration
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const t = testimonials[activeIndex];

    return (
        <section className="testimonials-section">
            <div className="title-wrapper">
                <span className="badge">Kundenmeinungen</span>
                <h2>Was sagen unsere Kunden über uns?</h2>
                <div className="divider">
                    <span className="dot" />
                    <span className="dot" />
                    <span className="dot" />
                    <span className="dot" />
                </div>
            </div>

            <div className="testimonial-wrapper">
                <div className={`testimonial-card ${transitionStage}`}>
                    <div className="header">
                        <div className="avatar">{t.name.charAt(0)}</div>
                        <div className="info">
                            <strong>{t.name}</strong>
                            <small>{t.subtitle}</small>
                            <div className="stars">{"★".repeat(t.stars)}</div>
                            <span className="time">{t.time}</span>
                        </div>
                    </div>

                    <p className="review-text">{t.review}</p>

                    {/* Outer Swiper wrapper for pagination */}
                    <Swiper
                        slidesPerView={1}
                        loop={true}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        pagination={{ clickable: true }}
                        modules={[Pagination, Autoplay]}
                        className="testimonial-outer-swiper"
                    >
                        {t.images.map((img, index) => (
                            <SwiperSlide key={index}>
                                <img src={img} alt={`img-${index}`} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>

            {/* Navigation buttons */}
            <div style={{ marginTop: "2rem", textAlign: "center" }}>
                {testimonials.map((_, idx) => (
                    <button
                        key={idx}
                        onClick={() => setActiveIndex(idx)}
                        style={{
                            margin: "0 5px",
                            background: activeIndex === idx ? "#555" : "#ddd",
                            color: activeIndex === idx ? "white" : "black",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            border: "none",
                            cursor: "pointer",
                        }}
                        aria-label={`Show testimonial ${idx + 1}`}
                    />
                ))}
            </div>
        </section>
    );
};

export default Testimonials;
